import styled from "styled-components";
import Fonts from "../../themes/Fonts";
import Colors from "../../themes/Colors";
import { fadeIn } from "../Common/CommonStyles";

//Input
export const Input = styled.input.attrs((props) => ({
  ...(props.type === "date" && {
    min: props.minDate || undefined,
    max: props.maxDate || undefined,
    lang: "es",
  }),
}))`
  padding: 10px;
  font-size: ${({ fontSize }) => fontSize || "16px"};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  border-radius: ${({ borderRadius }) => borderRadius || "4px"};
  border: 1px solid #ccc;
  outline: none;
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "15px"};
  maxlength: ${(props) => props.maxLength || undefined};

  /* Estilos adicionales según el estado del componente */
  &:focus {
    border-color: blue;
    box-shadow: 0 0 5px rgba(0, 0, 255, 0.3);
  }

  &::placeholder {
    color: #aaa;
  }

  /* Estilos responsive */
  @media (max-width: 844px) {
    font-size: ${({ responsiveFontSize }) => responsiveFontSize || "15px"};
    padding: ${({ responsivePadding }) => responsivePadding || "2px"};
    width: ${(props) => props.width || "350px"};
    height: 35px;
    animation: ${fadeIn} 0.5s ease-in;
  }

  @media (max-width: 320px) {
    width: 200px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const SuggestionsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  background-color: white;
  li {
    padding: 5px;
    cursor: pointer;

    &:hover {
      background-color: ${(props) =>
        props.hoverBgColor || Colors.primaryPrimera};
      color: white;
    }
  }
`;

//InputIcon
export const IconInputContainer = styled.div`
  display: ${({ display }) => display || "block"};
  flex: 1;
  position: ${({ position }) => position || "relative"};
  @media screen and (max-width: 844px) {
    position: relative;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const ErrorMessage = styled.div`
  color: ${Colors.huMyHealth};
  font-size: 14px;
  margin-top: 5px;
`;

//Select
export const Select = styled.select`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  width: ${(props) => props.width || ""};
  height: ${(props) => props.height || "37px"};
  @media (max-width: 844px) {
    font-size: ${({ responsiveFontSize }) => responsiveFontSize || "18px"};
    padding: ${({ responsivePadding }) => responsivePadding || "2px"};
    width: ${(props) => props.width || "350px"};
    height: 45px;
    animation: ${fadeIn} 0.5s ease-in;
  }
  @media (max-width: 320px) {
    width: 200px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const SelectContainer = styled.div`
  display: inline-block;
  position: relative;
`;

export const SelectField = styled.select`
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  appearance: none;
  cursor: pointer;
  width: ${(props) => props.width || "200px"};
  height: ${(props) => props.height || "47px"};
`;

export const SelectArrow = styled.div`
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 6px 0 6px;
  border-color: #666 transparent transparent transparent;
  pointer-events: none;
`;

//Form
export const FormWrapper = styled.div`
  border: ${(props) =>
    props?.borderColor
      ? "3px solid " + props?.borderColor
      : "3px solid " + Colors.primaryPrimera};
  padding: 20px;
  border-radius: 12px;
  flex: ${({ flex }) => flex || "1"};
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  flex-direction: ${({ flexDirection }) => flexDirection || "column"};
  display: ${({ display }) => display || "flex"};
  @media screen and (max-width: 844px) {
    flex-wrap: wrap;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const Form = styled.form`
  display: flex;
  margin-bottom: ${({ margin }) => margin || ""};
  margin-top: ${({ marginTop }) => marginTop || ""};
  margin-bottom: ${({ marginBottom }) => marginBottom || ""};
  flex-wrap: wrap;
  justify-content: ${({ justifyContent }) => justifyContent || "space-evenly"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "column"};
  width: calc(33.33% - 10px);
  margin-bottom: 20px;
  margin-right: ${(props) => props.isArl ? '309px' : '0'};
  @media screen and (max-width: 844px) {
    width: calc(33.33% - 20px);
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

//Label
export const Label = styled.label`
  margin-bottom: 5px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  color: ${(props) => props.color || "black"};
  font-weight: ${(props) => props.weight || "normal"};
  @media (max-width: 844px) {
    font-size: ${({ responsiveFontSize }) => responsiveFontSize || "18px"};
    padding: ${({ responsivePadding }) => responsivePadding || "2px"};
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const LabelWithContainer = styled.label`
  margin-bottom: 5px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  display: ${(props) => props.labelJustify || "flex"};
  width: ${(props) => props.labelWidth || "250px"};
  height: ${(props) => props.labelHeight || "50px"};
  background-color: ${(props) => props.labelBgColor || Colors.blueTransparent};
  color: ${(props) => props.labelTextColor || Colors.primaryPrimera};
  justify-content: ${(props) => props.labelJustify || "center"};
  line-height: ${(props) => props.labelLineHeigth || "50px"};
  font-weight: ${(props) => props.labelWeight || "bold"};
`;


// Checkbox
export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: 22px;
  height: 22px;
  background: ${(props) => (props.checked ? props.checkedColor : props.uncheckedColor)};
  border-radius: 3px;
  transition: all 150ms;
  cursor: pointer;
`;

export const CheckmarkIcon = styled.svg`
  fill: none;
  stroke: ${(props) => props.checkmarkColor};
  stroke-width: 2px;
`;